class Vesting {
  constructor(startTime, durationDays, cliffDays, tgeVestingPercentage, total) {
    this.startTime = startTime
    this.duration = durationDays * 24 * 60 * 60 // Convert days to seconds
    this.cliff = cliffDays * 24 * 60 * 60 // Convert days to seconds
    this.tgeVestingPercentage = tgeVestingPercentage
    this.total = total || 0 // Default to 0 if total is not provided
  }

  vestedAmount() {
    const timestamp = Math.floor(Date.now() / 1000)
    if (timestamp <= this.startTime) {
      return 0
    } else if (timestamp >= this.startTime + this.duration) {
      return this.total
    } else if (timestamp <= this.startTime + this.cliff) {
      return this.vestedAtTGE(this.total)
    } else {
      // Calculate the amount vested at TGE
      const amountVestedAtTGE = this.vestedAtTGE(this.total)
      const remainingAmount = this.total - amountVestedAtTGE

      // Linear vesting starts from the end of the cliff
      const vestingStartTime = this.startTime + this.cliff
      const elapsedTime = Math.max(0, timestamp - vestingStartTime) // Ensure no negative elapsed time
      const effectiveDuration = this.duration - this.cliff

      // Calculate the amount vested since the cliff
      const amountVestedSinceCliff =
        (remainingAmount * elapsedTime) / effectiveDuration

      // Total vested amount
      return amountVestedAtTGE + amountVestedSinceCliff
    }
  }

  vestedAtTGE(amount) {
    return (amount * this.tgeVestingPercentage) / 100
  }
}

export { Vesting }
